import React, { useEffect, useState } from "react";
import Navbar from "../componenst/Navbar";
import Header from "../componenst/compbooking/Header";
import Cardbooking from "../componenst/compbooking/Cardbooking";
import Loadlabel from "../skeleton/Loadlabel";
import Databookinglapangan from "./Databookinglapangan";
import { useParams } from "react-router-dom";

export default function Booking() {
  const { data } = useParams();
  const [load, setLoad] = useState(false);
  const [lapangan, setLapangan] = useState(true);
  const [databooking, setDatabooking] = useState(false);

  const handleLapangan = () => {
    setLapangan(true);
    setDatabooking(false);
  };
  const handledatabooking = () => {
    setLapangan(false);
    setDatabooking(true);
  };

  useEffect(() => {
    if (data == "data") {
      setDatabooking(true);
      setLapangan(false);
    } else {
      setDatabooking(false);
      setLapangan(true);
    }
    setTimeout(() => {
      setLoad(true);
    }, 500);
  }, []);
  return (
    <div>
      <Navbar judul="Booking" aicon="true" />
      <Header />
      <div className="booking-tabs-wrapper">
        <div className="booking-tabs">
          {load ? (
            <>
              <button
                onClick={handleLapangan}
                className={`booking-tab ${lapangan ? "active" : ""}`}
              >
                <i className="fas fa-futbol"></i>
                Lapangan Tersedia
              </button>
              <button
                onClick={handledatabooking}
                className={`booking-tab ${databooking ? "active" : ""}`}
              >
                <i className="fas fa-ticket-alt"></i>
                Data Booking
              </button>
            </>
          ) : (
            <Loadlabel />
          )}
        </div>
      </div>
      {lapangan ? <Cardbooking /> : <Databookinglapangan />}
    </div>
  );
}
